import CoursePreferences from './CoursePreferences';
import Wrapper from '../Wrapper';

const CoursePreferencesWrapper = () => (
  <Wrapper>
    <CoursePreferences />
  </Wrapper>
);

export default CoursePreferencesWrapper;
